/**
 * This is just a custom directive for coloring the chips when there is an error state
 */

const NS = 'ColoredChip';

export default function ColoredChip() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var mdChip = elem.parent().parent();
      if (scope.$chip.isIncompatiblePaymentType) {
        mdChip.addClass('is-incompatiblePaymentType');
      }
      if (scope.$chip.isArchived) {
        mdChip.addClass('is-archived');
      }
    }
  }
};
